// routes
import Iconify from '../../../components/iconify';
import { PATH_DASHBOARD } from '../../../routes/paths';

// ----------------------------------------------------------------------

const ICONS = {
  analytics: <Iconify icon="solar:chart-2-bold" />,
  inbox: <Iconify icon="solar:inbox-bold" />,
  reviewed: <Iconify icon="solar:check-read-bold" />,
  analyst: <Iconify icon="solar:clipboard-list-bold" />,
  approved: <Iconify icon="mdi:receipt-text-check" />,
  allClaims: <Iconify icon="solar:documents-minimalistic-bold" />,
  userManager: <Iconify icon="solar:users-group-rounded-bold" />,
  locate: <Iconify icon="solar:map-point-bold" />,
  animals: <Iconify icon="solar:paw-bold" />,
};

const navConfig = [
  // ['ANALYST', 'ADMINISTRATOR', 'SuperAdmin', "VIEWER", 'FUND MANAGER', 'BACK OFFICE']
  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'General',
    items: [
      {
        title: 'wild.dashboard',
        path: PATH_DASHBOARD.general.analytics,
        icon: ICONS.analytics,
        // roles: ['SuperAdmin', 'ADMINISTRATOR', 'ANALYST', 'VIEWER', 'PARTNER', '']
      },
      // USER
      {
        title: 'wild.claims_manager',
        path: PATH_DASHBOARD.task.list,
        icon: ICONS.inbox,
        roles: ['ANALYST', 'ADMINISTRATOR', 'SuperAdmin', 'BACK OFFICE', 'BACK OFFICE PLUS']
      },
      {
        title: 'wild.reviewed_claims',
        path: PATH_DASHBOARD.task.reviewedList,
        icon: ICONS.reviewed,
        roles: ['ADMINISTRATOR', 'SuperAdmin']
      },
      {
        title: 'wild.analyst_claims',
        path: PATH_DASHBOARD.task.analystClaims,
        icon: ICONS.analyst,
        roles: ['ANALYST', 'SuperAdmin']
      },
      {
        title: 'wild.approved_claims',
        path: PATH_DASHBOARD.task.approvedList,
        icon: ICONS.approved,
        roles: ['SuperAdmin', 'FUND MANAGER', 'PARTNER']
      },
      // update more roles when need arises
      {
        title: 'wild.all_claims',
        path: PATH_DASHBOARD.task.viewOnly,
        icon: ICONS.allClaims,
        roles: ['SuperAdmin', 'VIEWER']
      },
      {
        title: 'wild.user_manager',
        path: PATH_DASHBOARD.user.list,
        icon: ICONS.userManager,
        roles: ['SuperAdmin', 'ADMINISTRATOR']
      },
      {
        title: 'wild.cvo_locator',
        path: PATH_DASHBOARD.gps,
        icon: ICONS.locate,
        roles: ['SuperAdmin', 'ADMINISTRATOR', 'ANALYST', 'BACK OFFICE', 'BACK OFFICE PLUS']
      },
      {
        title: 'wild.animals_involved',
        path: PATH_DASHBOARD.general.animals,
        icon: ICONS.animals,
        roles: ['SuperAdmin', 'ADMINISTRATOR', 'ANALYST', 'BACK OFFICE', 'BACK OFFICE PLUS']
      },
    ],
  },
];

export default navConfig;
